import { Box, Slide } from "@mui/material";
import EventTimeline from "pages/LiveEventTracking/components/EventTimeline";
import SafeBoundary from "pages/LiveEventTracking/components/SafeBoundary";
import { useLiveEventsContext } from "context/LiveEventsContext";
import theme from "themeProvider";

// Dropdown panel below the header; removed from the page when closed.
const LiveEventsPanel = () => {
  const { hasAccess, events, isConnected, connectionError, isPanelOpen } =
    useLiveEventsContext();

  if (!hasAccess) return null;

  return (
    <Slide direction="down" in={isPanelOpen} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          // Let clicks pass through so the header bell still works.
          pointerEvents: "none",
        }}
      >
        <Box sx={{ ...theme.mixins.toolbar }} />
        <Box
          sx={{
            px: 4,
            py: 3,
            background: theme.palette.grey[100],
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
            boxShadow: "0 12px 28px rgba(16, 24, 40, 0.18)",
            pointerEvents: "auto",
          }}
        >
          <SafeBoundary name="LiveEventsPanel">
            <EventTimeline
              events={events}
              isConnected={isConnected}
              connectionError={connectionError}
            />
          </SafeBoundary>
        </Box>
      </Box>
    </Slide>
  );
};

export default LiveEventsPanel;
